import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton'; // Импортируем Skeleton
import { Link } from 'react-router-dom';

import { getUser, updateUserInfo } from '../services/Api'; // Импортируем функции getUser и updateUserInfo

import 'react-loading-skeleton/dist/skeleton.css'; // Импортируем стили для Skeleton

import { toast, ToastContainer } from 'react-toastify'; // Импортируем ToastContainer и toast

import 'react-toastify/dist/ReactToastify.css'; // Импортируем стили для toastify
import './Setting.css'; // Стили для страницы настроек

const SettingsPage = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subExpiresAt, setSubExpiresAt] = useState(null); // Состояние для даты окончания подписки
  const [isLoading, setIsLoading] = useState(true); // Состояние загрузки данных

  // Функция для преобразования временной метки в читаемую дату
  const timestampToDate = timestamp => {
    const date = new Date(timestamp * 1000); // Умножаем на 1000, чтобы перевести в миллисекунды
    return date.toLocaleDateString('ru-RU'); // Форматируем дату в формате ДД.ММ.ГГГГ
  };

  // Загрузка данных пользователя при монтировании компонента
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await getUser(); // Получаем данные пользователя
        if (userData) {
          setName(userData.name); // Устанавливаем имя
          setEmail(userData.email); // Устанавливаем email
          setSubExpiresAt(userData.subExpiresAt); // Устанавливаем дату окончания подписки
        }
      } catch (error) {
        console.error('Ошибка при загрузке данных пользователя:', error);
        toast.error('Не удалось загрузить данные пользователя', {
          position: 'top-right',
          autoClose: 5000
        });
      } finally {
        setIsLoading(false); // Завершаем загрузку
      }
    };

    fetchUserData();
  }, []);

  const handleSave = async e => {
    e.preventDefault();
    try {
      // Вызываем функцию обновления имени
      await updateUserInfo(name);
      toast.success('Изменения успешно сохранены!', {
        position: 'top-right',
        autoClose: 3000
      });
    } catch (error) {
      console.error('Ошибка при сохранении данных:', error);
      toast.error(error.message || 'Ошибка при сохранении данных', {
        position: 'top-right',
        autoClose: 5000
      });
    }
  };

  return (
    <div className="settings-page">
      <h1>Настройки</h1>
      <ToastContainer /> {/* Добавляем ToastContainer для отображения уведомлений */}
      {isLoading ? (
        // Скелетон во время загрузки
        <>
          <div className="settings-form">
            <div className="form-group">
              <label>
                <Skeleton width={100} /> {/* Скелетон для заголовка */}
              </label>
              <Skeleton height={40} /> {/* Скелетон для поля ввода */}
            </div>
            <div className="form-group">
              <label>
                <Skeleton width={100} /> {/* Скелетон для заголовка */}
              </label>
              <Skeleton height={40} /> {/* Скелетон для поля ввода */}
            </div>
            <Skeleton height={40} width={150} /> {/* Скелетон для кнопки */}
          </div>

          <div className="payment-history">
            <h2>
              <Skeleton width={150} /> {/* Скелетон для заголовка */}
            </h2>
            <p>
              <Skeleton width={200} /> {/* Скелетон для текста */}
            </p>
            <p>
              <Skeleton width={250} /> {/* Скелетон для текста */}
            </p>
          </div>
        </>
      ) : (
        // Основной контент после загрузки
        <>
          <form onSubmit={handleSave} className="settings-form">
            <div className="form-group">
              <label htmlFor="name">Ваше имя:</label>
              <input
                type="text"
                id="name"
                placeholder="Ваше имя"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                disabled // Поле email может быть недоступно для редактирования
              />
            </div>

            <button type="submit" className="save-button">
              Сохранить изменения
            </button>
          </form>

          <div className="payment-history">
            {/* <button className="history-button">История платежей</button> */}
            <p className="date-to">
              Аккаунт активирован до <br />
              <span>{subExpiresAt ? timestampToDate(subExpiresAt) : 'Нет данных'}</span>{' '}
              {/* Отображаем дату окончания подписки */}
            </p>
            <p className="more_info">Подробную информацию о вашей подписке можно получить по запросу в поддержке.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default SettingsPage;
